//Add 'scrolled' class to header when past it's height
var header = document.getElementById('main_heading');
var headerClassName = header.className;
var scrollPosition, headerClassScrolled;
document.addEventListener(
  'scroll',
  function () {
    headerClassScrolled = header.className.indexOf('scrolled');
    if (window.pageYOffset > header.offsetHeight && headerClassScrolled == -1) {
      //If scrolled past header height
      header.classList.add('scrolled');
      header.classList.add('activeAnimation');
    } else if (
      window.pageYOffset < header.offsetHeight &&
      headerClassScrolled != -1 &&
      !menuIsOpen
    ) {
      //Mobile support
      header.classList.remove('scrolled');
      header.classList.remove('open');
    } else if (window.pageYOffset < header.offsetHeight && menuIsOpen) {
      //Mobile support
      header.classList.add('open');
    }

    if (menuIsOpen) {
      //Open responsive menu
      header.style.transform = 'translateY(' + calcMenuHeight() + 'px)';
    }
  },
  {
    passive: true,
  },
);

//On load add scrolled class if below header
if (window.pageYOffset > header.offsetHeight && headerClassScrolled == -1) {
  header.classList.add('scrolled');
}

//Header open animation
var headerCheckbox = document.getElementById('mobile-nav-checkbox');
var menuIsOpen = false;

headerCheckbox.addEventListener('change', function (e) {
  e.preventDefault();
  if (!menuIsOpen) {
    //Open menu
    header.className += ' open';
    menuIsOpen = true;

    header.style.transform = 'translateY(' + calcMenuHeight() + 'px)';
  } else if (window.pageYOffset < header.offsetHeight) {
    //Close menu without srolled class
    header.className = headerClassName;
    menuIsOpen = false;

    header.style.transform = 'translateY(0px)';
  } else {
    //Close menu with scroll class
    header.className = headerClassName + ' scrolled';
    menuIsOpen = false;

    header.style.transform = 'translateY(0px)';
  }
});

function calcMenuHeight() {
  var mobileMenu = document.querySelector('.nav-mobile ul');
  headerClassScrolled = header.className.indexOf('scrolled');
  if (mobileMenu.offsetHeight + header.offsetHeight > window.innerHeight) {
    mobileMenu.style.height = window.innerHeight - header.offsetHeight + 'px';
    return window.innerHeight - header.offsetHeight;
  } else {
    return mobileMenu.offsetHeight - 10;
  }
}

export { calcMenuHeight };
